import { createAction } from 'redux-actions';

export const setLastMessageTime = createAction(
  'sessionTimer/SET_LAST_MESSAGE_TIME'
);

export const setIsSessionTimerLoading = createAction(
  'sessionTimer/SET_IS_LOADING'
);
